const services = [
  {
    title: "Individual therapy",
    body: "Anxiety, depression, life transitions, identity, grief. A space to think out loud without judgment.",
    tag: "Adults & teens",
  },
  {
    title: "Couples & marital",
    body: "Communication, trust, conflict that keeps repeating. Practical work to find each other again.",
    tag: "Partners",
  },
  {
    title: "Family & custody",
    body: "Navigating divorce, co-parenting, and custody concerns with the children's wellbeing at the center.",
    tag: "Families",
  },
  {
    title: "Juvenile & SED support",
    body: "Years working with children diagnosed with serious emotional disturbances and their families.",
    tag: "Youth",
  },
  {
    title: "LGBTQ+ affirming",
    body: "Lived experience, family ties, and professional work supporting the LGBTQ+ community.",
    tag: "Affirming",
  },
  {
    title: "Abuse recovery",
    body: "Confidential support for survivors of emotional, physical, or relational abuse — moving at your pace.",
    tag: "Trauma-aware",
  },
];

export function Services() {
  return (
    <section id="services" className="relative bg-card/40 py-24 sm:py-32">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,theme(colors.sage.DEFAULT/0.12),transparent_60%)]"
      />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.22em] text-sage-deep">
              What we work on
            </p>
            <h2 className="mt-4 max-w-2xl font-display text-4xl font-medium tracking-tight text-balance sm:text-5xl">
              Real issues. Real conversations. Real resources.
            </h2>
          </div>
          <p className="max-w-sm text-sm text-foreground/70">
            Sessions are available via secure telehealth or in person in Minnesota.
          </p>
        </div>

        <ul className="mt-14 grid gap-px overflow-hidden rounded-3xl border border-border bg-border sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <li
              key={s.title}
              className="reveal group relative flex flex-col gap-3 bg-card p-8 transition-colors hover:bg-secondary/60"
              style={{ transitionDelay: `${i * 50}ms` }}
            >
              <span className="text-xs font-medium uppercase tracking-[0.18em] text-clay">
                {s.tag}
              </span>
              <h3 className="font-display text-2xl font-medium leading-snug">{s.title}</h3>
              <p className="text-foreground/75 leading-relaxed">{s.body}</p>
              <span
                aria-hidden
                className="mt-4 inline-flex h-9 w-9 items-center justify-center rounded-full border border-border text-sage-deep transition-all group-hover:bg-sage-deep group-hover:text-cream"
              >
                →
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
